import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { WidgetService } from '../../../services/builder/widget.service';
import { CheckBoxCPanelComponent } from './customizationPanel';

export interface CheckBoxCustomization {
  defaultValue: boolean;
  autocompleteRule: boolean;
  required: boolean;
  weight: number;
}
@Component({
  selector: 'lib-checkbox-edit',
  imports: [CheckboxModule, CheckBoxCPanelComponent, FormsModule],
  template: `
    <!-- CONFIGURATION PANEL -->
    @if (widgetService.settingVisibility()) {
      <lib-checkbox-custom-panel />
    }

    <!-- OBJECT RAPRESENTATION -->
    @let widget = widgetService.widget();
    @if (widget) {
      <div class="relative flex w-full flex-row gap-2">
        <p-checkbox
          id="data"
          [ngModel]="widget.customization.defaultValue"
          [binary]="true"
          disabled
        />
        @if (!widgetService.baseElementShowDescription()) {
          <div
            class="flex flex-row items-center gap-2 whitespace-normal text-justify"
          >
            {{ widgetService.computedDescription() }}
          </div>
        }
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class CheckBoxComponent {
  protected dragDropService = inject(DragDropService);
  protected widgetService = inject(WidgetService<CheckBoxCustomization>);
}
